import { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useSnackbar } from "notistack";
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Paper, Button, Table, TableBody, TableCell, TableRow, TableHead, Tooltip, Checkbox, Grid, Box } from '@mui/material';
import { DeletePopUp, FilterComponent } from '../../../shared_elements';
import InfoIcon from '@mui/icons-material/Info';
import { LeasesNav } from '../../elements';
import { getUtilizationApi, deleteUtilizationApi } from '../apiService';
import { checkApiStatus } from '../../../utils';
import { globalGetService, globalDeleteService } from '../../../utils/globalApiServices';
import { rangeValidations, UtilizationList } from '../components';
import NoRecordFound from '../../../shared_elements/NoRecordFound';
import { PageLoader, STableLoader, Pagination } from '../../../shared_elements';
import { ButtonLoader, ShowAttachments } from '../../../shared_elements/components';
import LeasesBasicDetails from "../../elements/LeasesBasicDetails";
import { PermissionWrapper } from '../../../wrappers';
import { RoleBaseAccess } from '../../../hoc';
import RevisionHistory from '../../../shared_elements/components/RevisionHistory';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import fileUpload, { getApiResponse } from '../../../utils/fileUpload';
import FileUploadLayout from '../../../shared_elements/components/FileUploadLayout';
import {/* getLesseeApi, getLessorAc,getOwnerListApi, */ getStorage } from '../../../shared_elements/actionCreators';
import ModuleWiseRevisionHistory from '../../../shared_elements/components/ModuleWiseRevisionHistory';
import { setUploadFiles } from '../../../shared_elements/actions';
import { trackActivity } from '../../../utils/mixpanel';
import ModuleNotExcessModal from '../../../shared_elements/components/ModuleNotExcessModal';
import BackToLeaseList from '../../elements/BackToLeaseList';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const TABLE_HEIGHT = 'calc(100vh - 220px)';

const utilizationTypeOptions = [
    { label: 'Ferry Flight', value: 'Ferry Flight' },
    { label: 'CTA Entry for Delivery', value: 'CTA Entry for Delivery'},
    { label: 'Reporting Utilization', value: 'Reporting Utilization' },
    { label: 'Shop Visit', value: 'Shop Visit' },
    { label: 'Test Flight', value: 'Test Flight' },
];
const UtilizationHd = ({ toggleBulkOps, item, bulk }) => {
    const deliveryCond = item?.find((items) => items?.utilization_type?.value === 4) && item?.length === 1
    const notDisItem=item?.filter(optionItem=>(optionItem?.utilization_type?.value !== 4 && optionItem?.status?.value !== 3 && !optionItem?.invoice_exist))

    return (
        <TableHead>
            <TableRow>
                <TableCell className="table-actions-header" sx={{ minWidth: '140px' }}>
                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "utilization", operationType: ['D'] }}>
                        <Checkbox
                            color='primary'
                            size='small'
                            // disabled={item?.find((items) => items?.utilization_type?.value === 4) && item?.length === 1}
                            onChange={(e) => toggleBulkOps(e.target.checked, 'bulk', notDisItem)}
                            checked={notDisItem?.length === bulk?.ids?.length && notDisItem?.length > 0}
                        />
                    </PermissionWrapper>
                    Action(s)
                </TableCell>
                <TableCell sx={{ minWidth: '190px' }}> Period</TableCell>
                <TableCell sx={{ minWidth: '120px' }}> Flight Hours</TableCell>
                <TableCell sx={{ minWidth: '120px' }}> Flight Cycles</TableCell>
                <TableCell sx={{ minWidth: '100px' }}> FH:FC Ratio</TableCell>
                <TableCell sx={{ minWidth: '100px' }}> TSN</TableCell>
                <TableCell sx={{ minWidth: '100px' }}> CSN</TableCell>
                {item?.length > 0 && !item[0]?.stand_alone ? <TableCell sx={{ minWidth: '60px' }}> BH <Tooltip placement='top' title="Block Hours"><InfoIcon sx={{ cursor: 'pointer', fontSize: '14px', verticalAlign: 'sub', marginBottom: '1px' }} color="primary" /></Tooltip></TableCell> : null}
                {(item?.length > 0 && (!item[0]?.stand_alone || (item[0]?.stand_alone && item[0]?.asset_type === 2))) ? <TableCell sx={{ minWidth: '120px' }}> DeRate</TableCell> : null}
                {(item?.length > 0 && (!item[0]?.stand_alone || (item[0]?.stand_alone && item[0]?.asset_type === 2))) ? <TableCell sx={{ minWidth: '120px' }}> EGTM <Tooltip placement='top' title="EGT Margin"><InfoIcon sx={{ cursor: 'pointer', fontSize: '14px', verticalAlign: 'sub', marginBottom: '1px' }} color="primary" /></Tooltip></TableCell> : null}
                <TableCell sx={{ minWidth: '160px' }}> Location </TableCell>
                <TableCell sx={{ minWidth: '160px' }}> Utilization Type</TableCell>
                <TableCell sx={{ minWidth: '140px' }}> Invoice Status</TableCell>
                <TableCell sx={{ minWidth: "200px", whiteSpace: "nowrap"}}> Remarks </TableCell>
            </TableRow>
        </TableHead>
    )
}
const Utilizations = () => {
    const dispatch=useDispatch()
    const navigate = useNavigate()
    const location = useLocation();
    const { leaseSlug } = useParams();
    const params = { leaseSlug: leaseSlug }
    const { enqueueSnackbar } = useSnackbar()
    const [isLoading, setLoading] = useState(false)
    const [skeletonLoader, setSkeletonLoader] = useState(false)
    const [utilizationInfo, setUtilizationInfo] = useState({ list: [], pagination: {} });
    const [utilizationCRU, setUtilizationCRU] = useState({ modal: false, data: null, mode: '' });
    const [deleteUtilization, setDeleteUtilization] = useState({ modal: false, data: null, })
    const [bulk, setBulk] = useState({ modal: false, ids: [], title: '', type: '' })
    const [attachments, setAttachments] = useState({ modal: false, data: null })
    const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
    const { leaseBasicDetails,fileUploadDetails,uploadFiles /*,lessor, lessee,owner */ } = useSelector((state) => state.leases);
    const[isExport,seIsExport]=useState(false)
    const[uploadFileProgressData, setUploadFileProgressData]=useState({})
    const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
    const [slug, setSlug] = useState({})
    const [filter, setFilter] = useState({});

    const utilizationFilterMenu = {
        start_date: { title: 'Period Start Date', inputType: 'date' },
        end_date: { title: 'Period End Date', inputType: 'date' },
        // lessor_name_id: { title: 'Lessor/Holdco', inputType: 'dropdown', options: owner || [], valueKey: 'id', labelKey: 'name', multiple: true },
        // owner_id: { title: 'Owner/SPV', inputType: 'dropdown', options: owner || [], valueKey: 'id', labelKey: 'name', multiple: false },
        // lessee_id: { title: 'Lessee', inputType: 'dropdown', options: lessee || [], valueKey: 'id', labelKey: 'name', multiple: true },
        utilization_type: { title: 'Utilization Type', inputType: 'dropdown', options: utilizationTypeOptions, valueKey: 'value', labelKey: 'label', multiple: false },
        // block_hours_from: { title: 'BH (Block Hours) from', inputType: 'number', md: 6 },
        // block_hours_till: { title: 'BH (Block Hours) till', inputType: 'number', md: 6 },
        hours_from: { title: 'Flight Hours From', inputType: 'number', md: 6,is_decimal :true  },
        hours_till: { title: 'Flight Hours Till', inputType: 'number', md: 6 ,is_decimal :true },
        cycles_from: { title: 'Flight Cycles From', inputType: 'number', md: 6 ,is_decimal :true },
        cycles_till: { title: 'Flight Cycles Till', inputType: 'number', md: 6,is_decimal :true  },
        // derate: { title: 'DeRate', inputType: 'number', md: 6 },
        // egtm: { title: 'EGTM', inputType: 'number', md: 6 },
        tsn_from: { title: 'TSN From', inputType: 'number', md: 6 ,is_decimal :true },
        tsn_till: { title: 'TSN Till', inputType: 'number', md: 6,is_decimal :true  },
        csn_from: { title: 'CSN From', inputType: 'number', md: 6,is_decimal :true  },
        csn_till: { title: 'CSN Till', inputType: 'number', md: 6 ,is_decimal :true },
    };

    useEffect(() => {
        uploadFiles?.modal && handleUpload(uploadFiles?.slug, uploadFiles?.mode)
        const uploadedFileData = getApiResponse("utilization_master", slug);
        trackActivity('Page Viewed', { page_title: 'Utilization' })
        setUploadFileProgressData({ uploadedFileData });
             // if (!lessee?.length) dispatch(getLesseeApi());
             // if (!lessor?.length) dispatch(getLessorAc());
             // if (!owner?.length) dispatch(getOwnerListApi());
    }, [])

    useEffect(() => {
        if (!leaseBasicDetails?.slug) return;
        if (leaseBasicDetails?.status === "Draft") return;
        getUtilizationList('skeletonLoader', { per_page: 50 });
    }, [leaseBasicDetails?.status]);


    const getUtilizationList = (loaderType, query = {}) => {
        if (leaseBasicDetails?.status === "Draft") {
            return;
        }
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        globalGetService(getUtilizationApi(params, query)).then(response => {
            if (checkApiStatus(response)) {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
                setUtilizationInfo(response.data.data);
            } else {
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
            }
        })
        dispatch(getStorage({lease_slug:params?.leaseSlug,module_name:"utilization_master"}))
    }
    const toggleBulkOps = async (flag, type, item) => {
        try {
            if (type === 'bulk') {
                setBulk({ ...bulk, type: 'bulk', ids: flag ? item : [] });
            } else {
                setBulk({ ...bulk, type: 'single', ids: flag ? [...bulk.ids, item] : bulk?.ids?.filter(optionItem => optionItem.id !== item.id) })
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }
    const onDeteAttchments = (deltedslug) => {
        setAttachments({
            ...attachments, data: {
                ...attachments.data,
                attachments: attachments?.data?.attachments.filter(item => item?.slug !== deltedslug)
            }
        });
        if (utilizationCRU?.modal) {
            setUtilizationCRU({
                ...utilizationCRU,
                data: {
                    ...utilizationCRU.data,
                    attachments: utilizationCRU?.data?.attachments.filter(item => item?.slug !== deltedslug)
                }
            })
        }
        getUtilizationList('pageLoader', { per_page: utilizationInfo?.pagination?.per_page });
    }

    const deleteUtilizationFn = () => {
        let delteId = bulk?.ids?.filter((item) => item?.utilization_type?.value !== 4).map(item => item?.master_id) || [];
        setLoading(true);
        globalDeleteService(deleteUtilizationApi(params), { master_ids: bulk?.type === 'bulk' || bulk?.type === 'single' ? delteId : [deleteUtilization?.data?.master_id] }
        )
            .then(response => {
                if (checkApiStatus(response)) {
                    trackActivity('Item Deleted', { page_title: `Delete Utilization`, success_msg: response?.data?.message, item_ids: deleteUtilization?.data || bulk?.ids, response: response?.data })
                    setDeleteUtilization({ modal: false, data: null });
                    getUtilizationList('pageLoader', { per_page: utilizationInfo?.pagination?.per_page });
                    setBulk({ modal: false, ids: [], type: '' })
                    // setLoading(false);
                    enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                } else {
                    trackActivity('Item Deleted', { page_title: `Delete Utilization`, error_msg: response?.data?.message, item_ids: deleteUtilization?.data || bulk?.ids, response: response?.data })
                    setLoading(false);
                    setBulk({ modal: false, ids: [], type: '' })
                    enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                }
            })
    }

    const onEdit = (item) => {
        navigate(`/lease/${leaseSlug}/utilization/edit/${item.slug}`, {
            state: { mode: 'edit', data: item }
        });
    }
    const onCreate = () => {
        navigate(`/lease/${leaseSlug}/utilization/create`, {
            state: { mode: 'add', data: utilizationInfo?.list, leaseData: leaseBasicDetails }
        });
    }
    const onView = (item) => {
        navigate(`/lease/${leaseSlug}/utilization/view/${item.slug}`, {
            state: { mode: 'view', data: item }
        });
    }
    
    const handleExport=()=>{
         seIsExport(true);
         globalGetService(getUtilizationApi(params , { export: true})).then((response)=>{
            if (checkApiStatus(response)){
              enqueueSnackbar(
                     response?.data.message,
                     { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } }
                   );
                    seIsExport(false);
            }
        })
       }
    const handleUpload = async (slug, mode) => {
        setSlug({ slug: slug })
        await fileUpload({
            attachments: fileUploadDetails.attachments,
            module_name: "utilization_master",
            slug: slug,
            query: { record_action_type: mode },
            onProgress: ({ progressRefs, attachments, response }) => {
                setUploadFileProgressData({ progressRefs, attachments, response });
            },
            onSuccess: (success_msg) => {
                enqueueSnackbar(success_msg, {
                    variant: "success",
                    anchorOrigin: { vertical: "top", horizontal: "right" }
                });
                getUtilizationList('pageLoader', { per_page: utilizationInfo?.pagination?.per_page });
            },
            onError: (err) => {
                enqueueSnackbar(`${err?.message}` || "Error while uploading files", {
                    variant: "error",
                    anchorOrigin: { vertical: "top", horizontal: "right" }
                });
            }
        });
        dispatch(setUploadFiles({}));
        setSlug({})
    };  
    const onApplyFilter = (query) => {
           if (query.start_date && query.end_date && moment(query.start_date).isAfter(moment(query.end_date))) {
                    enqueueSnackbar('Period Start Date must be before End Date', { variant: 'error' });
                    return false;
                }
                for (const item of rangeValidations) {
                    const fromValue = query[item.from];
                    const tillValue = query[item.till];
                    if ( fromValue !== '' && fromValue !== null && fromValue !== undefined && tillValue !== '' && tillValue !== null && tillValue !== undefined ) {
                        const fromNum = Number(fromValue);
                        const tillNum = Number(tillValue);
                        if (isNaN(fromNum) || isNaN(tillNum)) { enqueueSnackbar( `${item.label} values must be valid numbers`, { variant: 'error' } ); return false; }
                        if (fromNum > tillNum) { enqueueSnackbar( `${item.label} From must be less than or equal to ${item.label} Till`, { variant: 'error' } ); return false; }
                    }
                }
        setFilter(query);
        getUtilizationList('', { ...query, page: 1, per_page: utilizationInfo?.pagination?.per_page || 50 });
    };
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Utilization`, page_type: page_type, })
    }

    return (
        <>
            <LeasesBasicDetails />
            <Paper className='lease-details-section lease-nav-module-margin lease-module-paper' elevation={0}>
                <LeasesNav />
                {leaseBasicDetails?.status === "Draft" ? (<ModuleNotExcessModal moduleName = 'Utilization'/>) : leaseBasicDetails && Object.keys(leaseBasicDetails).length > 0 && !leaseBasicDetails?.status ? (<ModuleNotExcessModal leaseNotFound />) :
                <div className='lease-details-content'>
                    <Paper square className="responsive-paper">
                            <Grid container spacing={1} className="responsive-grid utilization-header-grid" alignItems='end' sx={{ justifyContent: 'space-between', placeItems: "flex-start" }}>
                                <Grid item size={{ md: 12, xs: 12 }} sx={{marginBottom:"-12px", marginLeft: "3px"}} className="menu-container lease-list-link-mt">
                                    <BackToLeaseList />
                                </Grid>
                                <Grid size='grow' sx={{ minWidth: 0, overflow: 'hidden' }}>
                                    {!skeletonLoader ? <Box display="flex" alignItems="center"  gap={1} sx={{marginTop:'6px', marginLeft: "-3px" }} flexShrink={0}><FilterComponent filter={filter} filterMenu={utilizationFilterMenu} getResponseBack={onApplyFilter} /></Box> : null}
                                </Grid>
                            <Grid md={8} xs={12} className="utilization-actions-wrap" sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <ul className='list-inline lease-details-right-items lease-details-btn utilization-actions-list' style={{ padding: 0, float: 'right' }}>
                                    <li className='lease-mobile-button revision-history'><ModuleWiseRevisionHistory ViewGlobalHistory={() => setRevisionHistory({ modal: true, mode: '', data: { slug: params?.leaseSlug, type: "global" } })} /> </li>
                                    {bulk?.ids?.find((item) => item?.utilization_type?.value === 4) && bulk?.ids?.length === 1 ? null :
                                        bulk?.type && bulk?.ids?.length ?
                                            <>
                                                <li className='lease-mobile-button'>
                                                    <Button onClick={() => { setBulk({ modal: false, ids: [], title: '', type: '' }); handleItemClicked('Bulk Delete Cancel Button') }} size="small" variant="outlined" color="primary" >Cancel</Button>
                                                </li>
                                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "utilization", operationType: ['D'] }}>
                                                    <li className='lease-mobile-button'>
                                                        <Button onClick={() => { setBulk({ ...bulk, title: 'Delete', modal: true }); handleItemClicked('Bulk Delete Button') }} variant="outlined" size="small" sx={{ backgroundColor: "#f50057", color: "#fff", borderColor: "#f50057", }}>{`Delete (${bulk?.ids?.filter((item) => item?.utilization_type?.value !== 4)?.length})`}</Button>
                                                    </li>
                                                </PermissionWrapper>
                                            </> : null
                                    }
                                    {utilizationInfo?.list?.length > 0 ? <li className='lease-mobile-button'> <Button startIcon={isExport ? <ButtonLoader size={15} /> : <ArrowDownwardIcon />} onClick={() => { handleExport(); handleItemClicked('Export Button') }} variant="outlined" size='small' className='btn-primary action-btn-start-icon'> Export </Button>  </li> : null}
                                    <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "utilization", operationType: ['C'] }}>
                                        <li className='lease-mobile-button'>
                                            <Button disabled={isLoading || skeletonLoader} variant="contained" color="primary" size='small' startIcon={<AddOutlinedIcon />} className='action-btn-start-icon' onClick={() => { onCreate(); handleItemClicked('Add Item Button') }} > Add Utilization </Button>
                                        </li>
                                    </PermissionWrapper>
                                </ul>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper className='lease-detail-table table-container lease-module-paper ' elevation={0} sx={{ display: 'flex', flexDirection: 'column', maxHeight: TABLE_HEIGHT, height: utilizationInfo?.list?.length > 0 ? `${TABLE_HEIGHT} !important` : 'auto !important' }}>
                        <div style={{ flex: '1 1 auto', overflow: 'auto', minHeight: 0 }}>
                            {(skeletonLoader || !leaseBasicDetails?.slug) ? <STableLoader count={4} rowCount={11} /> : (
                                <Table className='mui-table-format' stickyHeader>
                                    <UtilizationHd bulk={bulk} item={utilizationInfo?.list} toggleBulkOps={toggleBulkOps} />
                                    <TableBody>
                                        {utilizationInfo?.list?.length > 0 && (location.state?.callBackData?.length > 0 ? location.state?.callBackData : utilizationInfo?.list)?.map((item, index) =>{
                                            const uploadedFileData = getApiResponse("utilization_master", item?.master_slug);
                                            return(
                                            <UtilizationList
                                                slug={slug?.slug}
                                                isWorkingGroup={utilizationInfo?.is_working_group}
                                                isInvoiceApproval={utilizationInfo?.is_invoice_approval}
                                                workingGroupMember={utilizationInfo?.finance_wg_members}
                                                uploadedFileData={uploadedFileData}
                                                uploadFileProgressData={uploadFileProgressData}
                                                viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
                                                key={index}
                                                item={item}
                                                bulk={bulk}
                                                onEditFn={() => onEdit(item)}
                                                onView={() => onView(item)}
                                                viewRevisonHistory={() => setRevisionHistory({ modal: true, data: {...item,slug:item?.master_slug}, mode: 'view',type:"list" })}
                                                ondeleteUtilizationFn={() => {
                                                    setDeleteUtilization({ modal: true, data: item, });
                                                    setBulk({modal: false, ids: [item], type: ''});
                                                }}
                                                toggleBulkOps={(e) => toggleBulkOps(e.target.checked, 'single', item)}
                                                onOpenAttachments={() => setAttachments({ modal: true, data: item })}
                                            />
                                        )})}
                                    </TableBody>
                                </Table>
                            )}
                        </div>
                        <Paper>
                            {!skeletonLoader && leaseBasicDetails?.slug && !utilizationInfo?.list?.length && <NoRecordFound />}
                            <Pagination
                                pagination={utilizationInfo?.pagination}
                                onPageChange={(event, newPage) => { getUtilizationList('pageLoader', { ...filter, page: newPage + 1, per_page: utilizationInfo.pagination.per_page, }); }}
                                onRowsPerPageChange={(e) => { getUtilizationList('pageLoader', { ...filter, page: 1, per_page: parseInt(e.target.value, 10), }); }}
                            />
                        </Paper>
                    </Paper>
                </div>}
            </Paper>
            {attachments.modal ?
                <ShowAttachments
                    moduleName="Utilization"
                    url='delete-attachment'
                    attachmentsData={attachments}
                    getResponseBack={onDeteAttchments}
                    toggleModalFn={() => setAttachments({ modal: false, data: null })}
                    onViewDisabled={utilizationCRU?.mode === 'view'}
                    permissionKey='utilization'
                /> : null
            }
            {deleteUtilization?.modal || bulk?.modal ?
                <DeletePopUp
                    modal={bulk?.modal ? bulk.modal : deleteUtilization.modal}
                    title={bulk.modal ? (bulk?.ids?.length > 0 && bulk?.ids?.length === (utilizationInfo?.list?.length || 0) ? 'Delete All Utilization' : 'Delete Selected Utilization') : 'Delete Utilization'}
                    content={bulk?.modal ? `Are you sure, you want to Delete ${bulk?.ids.length > 1 ? 'these' : 'this'} record ?` : `Are you sure, you want to Delete?`}
                    onToggleModal={() => bulk?.modal ? setBulk({ modal: false, ids: [] }) : setDeleteUtilization({ modal: false, data: null })}
                    onDeleteRecords={() => deleteUtilizationFn()}
                /> : null}
            { revisionHistory.modal &&  
                <RevisionHistory 
                 moduleName={revisionHistory?.type === "list" ? "utilization_master" :"utilization" }
                 revisionHistory={revisionHistory}
                 onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })}
               />
            }
            <FileUploadLayout
                uploadFileStatus={uploadFileStatus}
                open={uploadFileStatus?.modal}
                setUploadFileStatus={setUploadFileStatus}
                uploadFileProgressData={uploadFileProgressData}
                progressRefs={uploadFileProgressData?.progressRefs}
                attachments={uploadFileProgressData?.attachments}
                onDownloadComplete={()=> setSlug({})}
            />
            {isLoading ? <PageLoader /> : null}
        </>
    )
}
export default RoleBaseAccess(Utilizations, { application: 'lease_revamp', feature: 'utilization', operationType: ['R'] });
